module.exports = __webpack_public_path__ + "static/media/green5.09e8aa72.jpg";